import React from 'react'
import { Field, formValueSelector } from 'redux-form'
import { useSelector } from 'react-redux'

import EmptyState from '../../../../Shared/EmptyState'
import WrappedInput from '../../../../Shared/Forms/WrappedInput'
import DynamicInput from '../../../../Shared/Forms/DynamicInput'
import { FORM_NAME } from './Form'
import Fields from './Fields'

const options = [
  { label: 'None', value: 'none' },
  { label: 'JSON', value: 'json' },
  { label: 'form-data', value: 'form-data' },
  { label: 'x-www-form-urlencoded', value: 'x-www-form-urlencoded' },
]

export default function Auth({ action, stepId }) {
  const selector = formValueSelector(FORM_NAME)
  const type = useSelector(state => selector(state, 'body.type'))
  const method = useSelector(state => selector(state, 'method'))

  if (['delete', 'get'].includes(method)) {
    return (
      <EmptyState tight>
        <p>
          {(method || '').toUpperCase()} requests don't support an HTTP body.
        </p>
      </EmptyState>
    )
  }

  return (
    <div>
      <Field
        component={WrappedInput}
        name="body.type"
        label="Type"
        options={options}
      />
      {type !== 'none' &&
        (type === 'json' ? (
          <Field
            monospace
            component={DynamicInput}
            name="body.text"
            label="JSON"
            actionId={action.id}
            stepId={stepId}
          />
        ) : (
          <Fields
            actionId={action.id}
            stepId={stepId}
            field="body.fields"
            label="Field"
            pluralLabel="Fields"
          />
        ))}
    </div>
  )
}
